(function () {

  /***********************
   * PERFORMANCE HELPERS
   ***********************/
  let runScheduled = false;

  function scheduleRun() {
    if (runScheduled) return;
    runScheduled = true;

    // Run when browser is idle OR after 200ms
    if ("requestIdleCallback" in window) {
      requestIdleCallback(() => {
        runAltFont();
        runScheduled = false;
      }, { timeout: 200 });
    } else {
      setTimeout(() => {
        runAltFont();
        runScheduled = false;
      }, 150);
    }
  }


  /***********************
   * MAIN ALT-FONT LOGIC
   ***********************/
  const specialCharPattern = /[^\p{L}\s]/gu;
  const skipTags = ['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'CODE', 'PRE'];

  function hasAltAncestor(node) {
    let cur = node.parentNode;
    while (cur && cur.nodeType === 1) {
      if (cur.classList && cur.classList.contains('alt-font')) return true;
      cur = cur.parentNode;
    }
    return false;
  }

  function normalizeAltSpans(root) {
    const nested = root.querySelectorAll('.alt-font .alt-font');
    nested.forEach(inner => {
      const outer = inner.parentElement;
      if (!outer) return;
      outer.textContent = inner.textContent;
      outer.className = 'alt-font';
    });
  }

  function wrapSpecialChars(node) {
    if (!node) return;
    if (node.nodeType === 1 && skipTags.includes(node.tagName)) return;

    node.childNodes.forEach(child => {
      if (child.nodeType === 3) {
        if (hasAltAncestor(child)) return;

        const text = child.nodeValue;
        if (!text || !text.match(specialCharPattern)) return;

        const fragment = document.createDocumentFragment();
        let lastIndex = 0;

        text.replace(specialCharPattern, (match, index) => {
          if (index > lastIndex) {
            fragment.appendChild(document.createTextNode(text.slice(lastIndex, index)));
          }
          const span = document.createElement('span');
          span.className = 'alt-font';
          span.textContent = match;
          fragment.appendChild(span);
          lastIndex = index + match.length;
        });

        if (lastIndex < text.length) {
          fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
        }

        child.replaceWith(fragment);
      }

      else if (child.nodeType === 1) {
        if (child.classList && child.classList.contains('alt-font')) return;
        wrapSpecialChars(child);
      }
    });
  }

  function runAltFont() {
    const targets = document.querySelectorAll(
      'main, .product__description, .rte, .shopify-section, section'
    );

    targets.forEach(el => {
      wrapSpecialChars(el);
      normalizeAltSpans(el);
    });
  }


  /***********************
   * INITIAL RUN
   ***********************/
  scheduleRun();


  /***********************
   * MUTATION OBSERVER (Throttled)
   ***********************/
  let moTimer;
  const observer = new MutationObserver(() => {
    clearTimeout(moTimer);
    moTimer = setTimeout(() => {
      scheduleRun();
    }, 60);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });


  /***********************
   * SHOPIFY SECTION EVENTS
   ***********************/
  document.addEventListener('shopify:section:load', scheduleRun);
  document.addEventListener('shopify:section:reorder', scheduleRun);
  document.addEventListener('shopify:section:select', scheduleRun);

})();
